const capitalProgramTypes = [ 
  {
    id: 'CPT00',
    title: 'Deuda',
    index: 1,
    helpKey: 'CPT00H',
    color: '#0070c0',
    branch: 'A',
    colorFilterValues: {
      invert: '29',
      sepia: '97',
      saturate: '1241',
      hueRotate: '182',
      brightness: '93',
      contrast: '102'
    }
  },
  {
    id: 'CPT01',
    title: 'Equity',
    index: 2,
    helpKey: 'CPT01H',
    color: '#0070c0',
    branch: 'A',
    colorFilterValues: {
      invert: '29',
      sepia: '97',
      saturate: '1241',
      hueRotate: '182',
      brightness: '93',
      contrast: '102'
    }
  },
  {
    id: 'CPT02',
    title: 'Crypto Tokens',
    index: 3,
    helpKey: 'CPT02H',
    color: '#0070c0',
    branch: 'A',
    colorFilterValues: {
      invert: '29',
      sepia: '97',
      saturate: '1241',
      hueRotate: '182',
      brightness: '93',
      contrast: '102'
    }
  },
  {
    id: 'CPT04',
    title: 'Garantía Corporativa',
    index: 4,
    helpKey: 'CPT04H',
    color: '#0070c0',
    branch: 'B',
    colorFilterValues: {
      invert: '29',
      sepia: '97',
      saturate: '1241',
      hueRotate: '182',
      brightness: '93',
      contrast: '102'
    }
  }
]
export default capitalProgramTypes
